import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">最新更新</h2>
            <p className="text-foreground-500 text-sm max-w-md">最新话刚刚更新，赶紧追更吧</p>
          </div>
          <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            更多更新 →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 font-medium rounded-full">NEW</span>
                  <span className="text-xs text-foreground-400">{comic.category}</span>
                </div>
                <h3 className="font-heading text-foreground-900 text-base mb-1">{comic.title}</h3>
                <p className="text-foreground-500 text-xs mb-3">作者: {comic.author}</p>
                {comic.chapters.length > 0 && (
                  <div className="space-y-1.5">
                    {comic.chapters.map((ch) => (
                      <div key={ch.id} className="flex items-center justify-between text-xs">
                        <span className="text-foreground-700">{ch.title}</span>
                        <span className="text-foreground-400">{ch.updatedAt}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}